import { map, Observable, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cookies, getCookie } from '../../utils/cookies';
import { getUserProfileId } from '../../utils/userProfile';
import { getDefaultRequestHeaderParams } from '../../utils/getRequestHeaderParams';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';
import { getBrand } from '../../utils/getBrand';
import { RealmName } from '../types/enum';

@Injectable({
  providedIn: 'root',
})
export class VaSessionService {
  constructor(private http: HttpClient) {}

  startSession(userName: string): Observable<any> {
    return this.http
      .post<{ token: string }>(
        getChatApiBaseUrl() + '/ucx-session/token',
        {
          profileId: getUserProfileId(),
          userName: userName,
        },
        {
          headers: {
            ...getDefaultRequestHeaderParams(),
          },
          withCredentials: true,
        }
      )
      .pipe(
        switchMap(() => {
          const sessionIdentifier = getCookie(Cookies.SESSION_IDENTIFIER);
          const expiryDate = new Date(Number(getCookie(Cookies.UCX_EXPIRY)));
          const realm =
            getBrand().name === RealmName.fido
              ? RealmName.fido
              : RealmName.rogers;
          return this.http
            .post<{ token: string }>(getChatApiBaseUrl() + '/va/session', {
              userName: userName,
              realm,
            })
            .pipe(
              map((res) => {
                return { token: res.token, expiryDate, sessionIdentifier };
              })
            );
        })
      );
  }

  updateChatType(sessionId: string, chatId: string): Observable<any> {
    return this.http.patch(
      getChatApiBaseUrl() + `/ucx-session/session-identifier/${sessionId}`,
      {
        chatType: 'LIVE_CHAT',
        chatId: chatId,
      },
      {
        headers: {
          ...getDefaultRequestHeaderParams({
            'session-identifier': sessionId,
          }),
        },
        withCredentials: true,
      }
    );
  }
}
